import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export class SASlideShowPage extends SlideShowPage{
    constructor(texture?:PIXI.Texture, secondTexture?:PIXI.Texture, textString?:string, backgroundColor?:number, imageLeft:boolean = true) {
        super(texture, textString, backgroundColor, imageLeft);

        if (secondTexture != undefined) {
            const image = new PIXI.Sprite(secondTexture);
            image.anchor.x = imageLeft ? 0 : 1;
            image.anchor.y = 0.5;
            image.position.x = imageLeft ? 10 : -10;
            this.addChild(image);
        }
    }

}